var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsbaggagescan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-434-382H716v754H-434z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.383 107.433h31.53l-4.715-15.086h28.55V32.004h-79.2v60.343h28.55l-4.715 15.086zm5.13-3.772l3.535-11.314h14.2l3.535 11.314h-21.27zM28.318 88.576v-52.8h71.657v52.8H28.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.434 55.576h-3.772a3.771 3.771 0 0 0-3.771 3.771v12.257a3.771 3.771 0 0 0 3.771 3.772h3.772v5.657H35.862V59.347h3.772v16.029a3.771 3.771 0 0 0 3.771-3.772V59.347a3.771 3.771 0 0 0-3.771-3.771h-3.772V43.318H94.32v-3.771H32.091v45.257h64.114V48.033h-3.771v7.543zm0 16.028h-3.772V59.347h3.772v12.257z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.605 48.976v6.6h-3.771a3.771 3.771 0 0 0-3.772 3.771v12.257a3.771 3.771 0 0 0 3.772 3.772h22.628a3.771 3.771 0 0 0 3.772-3.772V59.347a3.771 3.771 0 0 0-3.772-3.771h-3.771v-6.6H56.605zm3.771 3.771h7.543v2.829h-7.543v-2.829zm15.086 6.6v12.257H52.834V59.347h22.628z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsbaggagescan);
export default __webpack_public_path__ + "static/media/iconsbaggagescan.9a4b205d7998b0fa9b4903af87636f03.svg";
export { ForwardRef as ReactComponent };